<!--
  ~ Copyright (C) Compliance Audit Systems Limited - All Rights Reserved
  ~ Unauthorised copying of this file, via any medium is strictly prohibited
  ~ Proprietary and confidential
  ~ Written by Sudara Fernando <sudara@complianceauditsystems.com>, ${DATE}
  ~
  -->
<h1 class="title">Sites and Projects</h1>
<h5>Manage individual sites and projects</h5>
<p-tabView orientation="right" (onChange)="selectTab($event)" [activeIndex]="index">
    <p-tabPanel header="Sites">
        <ng-template pTemplate="content">
            <acabim-admin-site-list #siteList></acabim-admin-site-list>
        </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Archived Sites">
        <ng-template pTemplate="content">
            <acabim-admin-archived-sites #archivedSiteList></acabim-admin-archived-sites>
        </ng-template>
    </p-tabPanel>
</p-tabView>
